import { render, staticRenderFns } from "./AtosInfralegaisPorEnteFederativo.vue?vue&type=template&id=5ab25012&scoped=true"
import script from "./AtosInfralegaisPorEnteFederativo.vue?vue&type=script&lang=js"
export * from "./AtosInfralegaisPorEnteFederativo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AtosInfralegaisPorEnteFederativo.vue?vue&type=style&index=1&id=5ab25012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab25012",
  null
  
)

export default component.exports